module.exports = __webpack_public_path__ + "img/reset.84fcc0f6.svg";